import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getFirebaseBackend } from 'src/app/authUtils';
import { SKIP_AUTH } from 'src/app/core/helpers/http-context';

export interface VeraChatResponse {
	reply?: string;
	message?: string;
	output?: string;
	/** Optional quick-reply choices the backend wants rendered as buttons (single option or array). */
	options?: Record<string, any> | Record<string, any>[];
	[key: string]: any;
}

@Injectable({
	providedIn: 'root',
})
export class VeraService {
	constructor(private http: HttpClient) {}

	/**
	 * Sends a message to the Vera N8N workflow. Always includes the logged-in
	 * user_id so the workflow can scope any data lookups/responses to that user.
	 * `selectedOption` is included when the message was produced by the user
	 * tapping one of the option buttons, so the workflow gets the raw option
	 * payload (e.g. campaign_id) instead of having to re-parse the display text.
	 */
	sendMessage(message: string, sessionId: string, selectedOption?: Record<string, any>): Observable<VeraChatResponse> {
		const authUser = getFirebaseBackend()?.getAuthenticatedUser();

		const payload = {
			user_id: authUser?.IdUser ?? null,
			user_name: [authUser?.FirstName, authUser?.LastName].filter(Boolean).join(' ') || null,
			user_email: authUser?.email ?? null,
			session_id: sessionId,
			current_date: new Date().toISOString(),
			message,
			...(selectedOption ? { selected_option: selectedOption } : {}),
		};

		return this.http.post<VeraChatResponse>(environment.veraWebhookUrl, payload, {
			context: new HttpContext().set(SKIP_AUTH, true),
		});
	}
}
